export const bidding = (bids) => {
    console.log('bid socket updated successfully')
    return {
        type: 'Bidding',
        bidding: bids,
    }
}
